<template>
  <v-card>
    <v-card-title style="height: 64px;">
      <span class="title">{{title}}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-container grid-list-md class="py-2">
        <v-form ref="form" v-model="valid">
          <v-layout>
            <v-flex>
              <v-select
                :disabled="readonly"
                :rules="[$rules.requiredS()]"
                :label="'停车场区'"
                :loading="memberLoading"
                :items="parkingLotSelects"
                item-text="name"
                return-object
                v-model="parkingLots"
                :no-data-text="'没有可选项'"
                :hide-no-data="memberLoading"
                chips
                multiple
                deletable-chips
              ></v-select>
            </v-flex>
          </v-layout>
          <v-divider class="my-4"></v-divider>
          <v-layout row align-center>
            <v-flex class="px-2" xs8>
              <span class="subheading grey--text" >每天可预约车辆数</span>
            </v-flex>
            <v-flex xs4 offset-xs2>
              <v-text-field
                :rules="[...$rules.positiveInteger]"
                type="number"
                v-model="newConfig.times"
                :disabled="readonly"
                suffix="辆"
              ></v-text-field>
            </v-flex>
            <!--<v-flex>-->
            <!--<v-text-field-->
            <!--prepend-icon="directions_car"-->
            <!--label="最大允许添加车辆数"-->
            <!--v-model="newConfig.max"-->
            <!--&gt;</v-text-field>-->
            <!--</v-flex>-->
          </v-layout>
        </v-form>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat large @click="cancel" color="grey">取消</v-btn>
      <v-btn :disabled="!valid" flat large :loading="loading" @click="confirm" color="primary">确定</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

function Config (m = 0) {
  return {
    parkingLot: null,
    times: 0
  }
}

export default {
  name: 'parkingLotConfigContent',
  props: {
    maxItem: {type: Number, default: 100},
    mustInput: {type: Boolean, default: false},
    objectLabel: {type: String, default: '名称'},
    status: {type: String, default: 'new'},
    rawItem: {type: Object},
    loading: {type: Boolean, default: false},
    params: {type: Object},
    getSelection: {type: Function}
  },
  data: () => ({
    valid: false,
    newConfig: {},
    search: '',
    searchItems: [],
    memberLoading: false,
    parkingLots:[]
  }),
  computed: {
    owner () {
      return this.searchItems.find(v => v.id === this.newConfig.ownerId)
    },
    parkingLotSelects () {
      let selects = []
      if (this.items instanceof Array) {
        selects = this.items
      }
      else if (this.itemsP instanceof Array) {
        selects = this.itemsP
      }
      else if (this.$store.state.parkingLot.parkingLotList instanceof Array) {
        selects = this.$store.state.parkingLot.parkingLotList.slice()
      }
      if (selects.length === 0) {
        selects.push({header: '没有可选停车场区'})
      }
      if(selects.length!==0){
        selects.sort(function (a,b) {
          if(a.name>b.name){
            return 1
          }else if(a.name<b.name){
            return -1
          }else{
            return 0
          }
        })
      }
      return selects
    },
   /* dark () {
      return this.$store.state.dark
    },*/
    readonly () {
      return this.status === 'readonly'
    },
    editing () {
      return this.status === 'edit'
    },
    newItem () {
      return this.status === 'new'
    },
    title () {
      if (this.readonly) {
        return '查看配置'
      }
      else if (this.editing) {
        return '修改配置'
      }
      else {
        return '添加配置'
      }
    }
  },
  methods: {
    confirm () {
      this.parkingLots.sort(function (a,b) {
        if(a.name === b.name){
          return 0
        }else if(a.name>b.name){
          return 1
        }else{
          return -1
        }
      })
      let obj = {
        name:"",
        id:""
      }
      for(let i=0;i<this.parkingLots.length;i++){
        if(i===this.parkingLots.length-1){
          obj.name+=this.parkingLots[i].name
          obj.id+=this.parkingLots[i].id
        }else{
          obj.name+=(this.parkingLots[i].name+',')
          obj.id+=(this.parkingLots[i].id+',')
        }
      }
      this.newConfig.parkingLot = obj
      // logger.debug('submit', this.util.deepClone(this.newConfig))
      if (this.$refs.form.validate()) {
        this.$emit('confirm', {newItem: this.newConfig, oldItem: this.rawItem, status: this.status})
      }
    },
    cancel () {
      this.$emit('cancel')
    }
  },
  async created () {
    this.newConfig = new Config()
    if (this.readonly || this.editing) {
      this.newConfig = Object.assign(this.newConfig, this.rawItem || {})
      this.searchItems = [this.newConfig.owner]
      this.parkingLots = this.rawItem.parkingLots
    }
  }
}
</script>

<style scoped>

</style>
